import styled from "styled-components";
import { Image } from "@chakra-ui/react";

export const Container = styled.div`
  --card-width: 20.625rem;
  --card-height: 31.25rem;
  --btn-width: 6.125rem;
  --btn-height: 1.75rem;
  --font-size: 15px;
  --btn-font-size: 15px;

  margin: 50px 0;
  display: flex;
  border: 1px solid #cccccc;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 5px;
  background-color: white;
  z-index: 2;
  width: var(--card-width);
  height: var(--card-height);
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;

  .img {
    width: 100%;
    height: 80%;
    /* object-fit: cover; */
  }
  .infor {
    display: grid;
    grid: auto / 25% auto;
    margin-left: 10px;
    margin-top: 7px;
    font-size: var(--font-size);
  }
  
  .acoes{
    display: flex;
    justify-content: space-between;
    padding-top: 0.3125rem;
    border-top: 1px solid #cccccc;
  }

  .btn-editar{
    margin-left: 0.5rem;
  }

  .btn-vermais{
    display: flex;
    width: 100%;
    justify-content: right; 
    margin-bottom: 0.1875rem;
  }

  .btn {
    margin-bottom: 0.25rem;
    margin-right: 0.9375rem;
    width: var(--btn-width);
    height: var(--btn-height);
    padding: 0.3125rem;
    background-color: #3f3d56;
    color: #ffffff;
    border-radius: 7px;
    font-size: var(--font-size);
  }


  .img-modal {
    width: 100%;
    height: 100px;
    border-radius: 50px;
    /* object-fit: cover; */
  }

  .label-erro {
    display: block;
    color: "red";
    margin-left: "10px";
    font-size: 0.8125rem;
  }

  @media screen and (max-width: 1100px) {
    --card-width: 300px;
    --card-height: 500px;
    --font-size: 16px;
    --btn-font-size: 16px;
  }

  @media screen and (max-width: 1000px) {
    --card-width: 250px;
    --card-height: 430px;
    --btn-width: 100px;
  }

  @media screen and (max-width: 800px) {
    --card-width: 250px;
    --card-heigh: 430px;
    --btn-width: 90px;
    --bnt-height: 24px;
    --font-size: 14px;
    --btn-font-size: 14px;
  }

  @media screen and (max-width: 470px) {
    --card-width: 220px;
    margin-right: 25px;
    margin-top: 25px;
  }

  @media screen and (max-width: 470px) {
    --btn-width: 76px;
    --bnt-height: 24px;
    --btn-font-size: 12px;
  }
`;

export const StyledImage = styled(Image)`
  width: 100%;
  border-radius: 8px;
  margin-top: 10px;
  height: 650px;
`;
